import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import styles from "modules/home/home.module.scss";
import ShowMoreAndLess from "modules/product/showMoreAndLess/ShowMoreAndLessContainer";
import { useTranslation } from "next-i18next";
import { createMakeImageSource } from "util/vehicle/createMakeImageSource";
import { POPULAR_MAKE_MODELS } from "../site-structure/accessories-make/constant";
import Content from "./car-parts/Content";
import TabGroup from "./v2/tabs/TabGroup";

export default function FeaturedMakeAndManufacture(props) {
  const { content, heading } = props;

  const { t } = useTranslation("home");
  // add make_model_url in last model
  const modelsWithTransform = POPULAR_MAKE_MODELS
    .map((item) => ({
      ...item,
      models: [
        {

          url: item.url || item.makeCategoryUrl,
          img: createMakeImageSource({
            make: item.make.toUpperCase(),
          }),
          displayableModel: t("all_models", { make: item.make }),
          isMake: true,
          popular: true,
        },
        ...item.models,
      ],
    }));

  return (
    <>

      <div className={`${styles.section} ${styles.service_section} ${styles.service_section_padding}`}>

        <PAText
          bold
          component="h2"
          fontSize={FONT_SIZE[5]}
          className="d-flex align-items-center justify-content-center"
          style={{ width: "100%", marginTop: 0 }}
        >
          {t(heading || t("buy_oem_parts"))}
        </PAText>
        <ShowMoreAndLess
          contentDescription={(
            <PAText
              component="p"
              className={`${styles.aftermarket_parts_h2} ${styles.sub_content} m-t-0 m-b-20`}
            >
              <Content content={content || t("buy_oem_parts_description")} />
            </PAText>
          )}
          defaultHeight={5}
          style={{ maxHeight: "calc(5 * var(--safari-root-font, 10px))" }}
          className={styles.show_more_less_container}
        />

        <div className={styles.featured_make_section}>
          <TabGroup
            data={modelsWithTransform}
            showArrowOnHover
            showScrollOnHover
            autoplay={false}
            grayBackground
            component="h3"
          />
        </div>
      </div>
    </>
  );
}
